import React, {useState, useEffect, useRef} from "react";
import Popup from "../components/PopUP";
import UserActivateModal from "../components/UserActivateModal";
import UserDeactivateModal from "../components/UserDeactivateModal";
import DeleteModal from "../components/DeleteModal";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Link} from "react-router-dom";
import TableFooter from "../components/TableFooter";
import api from "../Api";
import {IMAGE_URL} from "../utils/constants";

export default function SubAdmin() {
    const [query, setQuery] = useState("");
    const [debouncedQuery, setDebouncedQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("info")
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(0);
    const [subAdmin, setSubAdmin] = useState({results: []});

    const [pagination, setPagination] = useState({
        count: 0,
        total_pages: 0,
        next: 0,
        previous: 0,
    });

    const [showActiveModal, setActiveShowModal] = useState(false);
    const [showDeactiveModal, setDeactiveShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showPasswordResetConfirm, setShowPasswordResetConfirm] =
        useState(false);
    const [isResettingPassword, setIsResettingPassword] = useState(false);

    // Search input ref
    const searchRef = useRef(null);

    // Focus search input when page loads
    useEffect(() => {
        searchRef.current?.focus();
    }, []);

    // Debounce the search query
    useEffect(() => {
        const t = setTimeout(() => {
            setDebouncedQuery(query);
            setCurrentPage(1);
        }, 400);

        return () => clearTimeout(t);
    }, [query]);

    // Fetch sub-admins
    useEffect(() => {
        const fetchSubAdmins = async () => {
            setLoading(true);

            try {
                const response = await api.get(
                    `/user-service/user/admin/users?page=${currentPage}&q=${debouncedQuery}`
                );

                console.log("API Response:", response.data);

                setSubAdmin(response.data);

                setPagination({
                    count: response.data.count,
                    total_pages: response.data.total_pages,
                    next: response.data.next,
                    previous: response.data.previous,
                });
            } catch (error) {
                console.error("API Error:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSubAdmins();
    }, [debouncedQuery, currentPage, refresh]);

    const handleDeleteClick = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    };

    const handleDeactivateClick = (item) => {
        console.log("Item to deactivate:", item);
        setSelectedItem(item);
        setDeactiveShowModal(true);
    };

    const handleActivateClick = (item) => {
        console.log("Item to activate:", item);
        setSelectedItem(item);
        setActiveShowModal(true);
    };

    const CallUserDeleteAPI = async () => {
        console.log("calling user delete")

        try {
            const response = await api.delete(`/user-service/user/admin/${selectedItem.user_id}`)
            console.log("delete response ", response.data)
            setPopupType("success")
            setPopupMessage(response.data.detail);
        } catch (e) {
            const errorMessage =
                e?.response?.data?.detail ||
                e?.response?.data?.message ||
                "Something went wrong. Please try again.";
            setPopupType("danger")
            setPopupMessage(errorMessage);
        }

    }

    const handleConfirmDelete = async () => {
        setShowModal(false);
        setSelectedItem(null);
        console.log("click on delete");
        console.info("selectedItem", selectedItem);
        await CallUserDeleteAPI()
        setRefresh((prev) => prev + 1);
    };

    const handleConfirmActivation = async (reason) => {
        console.log("activating:", selectedItem.user_id);

        try {
            const response = await api.patch("/user-service/user/status", {
                user_id: selectedItem.user_id,
                action: "activate",
                reason: reason?.trim() || "",
            });

            console.log("Activation response:", response.data);
            setPopupType("success")
            setPopupMessage("User activated successfully");
        } catch (error) {
            console.log("Activation error:", error);
            setPopupType("danger")
            setPopupMessage("Unable to activate user, please try again.");
        }

        setActiveShowModal(false);
        setSelectedItem(null);
        setRefresh((prev) => prev + 1);
    };

    const handleConfirmDeactivateClick = async (reason) => {
        console.log("deactivation:", selectedItem.user_id);

        try {
            const response = await api.patch("/user-service/user/status", {
                user_id: selectedItem.user_id,
                action: "deactivate",
                reason: reason?.trim() || "",
            });

            console.log("Deactivation response:", response.data);
            setPopupType("success")
            setPopupMessage("User deactivated successfully");
        } catch (error) {
            console.log("Deactivation error:", error);
            setPopupType("danger")
            setPopupMessage("An error occurred during deactivation");
        }

        setDeactiveShowModal(false);
        setSelectedItem(null);
        setRefresh((prev) => prev + 1);
    };

    const handleResetPasswordClick = (item) => {
        setSelectedItem(item);
        setShowPasswordResetConfirm(true);
    };

    const handleConfirmPasswordReset = async () => {
        setIsResettingPassword(true);

        try {
            const response = await api.get(
                `/user-service/user/admin/resend-password/${selectedItem.user_id}`
            );

            console.log("Password reset:", response.data);
            setPopupType("success")
            setPopupMessage("Password reset email sent successfully");
            setShowPasswordResetConfirm(false);
        } catch (error) {
            console.error("API Error:", error.message);
            setPopupType("danger")
            setPopupMessage("Failed to send password reset email");
        } finally {
            setIsResettingPassword(false);
            setSelectedItem(null);
        }
    };

    return (
        <>
            <div className="user-management-page">
                <Popup
                    message={popupMessage}
                    type={popupType}
                    onClose={() => setPopupMessage("")}
                />

                <Sidebar/>

                <div className="main-wrapper">
                    <Header/>

                    <div className="content-wrapper">
                        <section className="main-section spacer-y">
                            <div className="container">
                                <div className="row gy-4">
                                    <div className="col-xl-12">

                                        <div className="common_main_bg_wrapper">
                                            <div className="common_main_heading_wrapper">
                                                <div className="vstack">
                                                    <h1>Sub Admin Management</h1>
                                                </div>

                                                <div className="d-flex flex-end">
                                                    <Link
                                                        to="/add-sub-admin"
                                                        className="secondary_btn"
                                                    >
                                                        + Add Sub Admin
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Table */}
                                        {loading ? (
                                            <div
                                                className="d-flex justify-content-center align-items-center"
                                                style={{minHeight: "300px"}}
                                            >
                                                <div
                                                    className="spinner-border text-primary"
                                                    role="status"
                                                >
                          <span className="visually-hidden">
                            Loading...
                          </span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="common-table-wrapper mt-4">

                                                <div className="common-table-filter-wrapper">

                                                    <div className="common-left-blk">
                                                        <div className="common_sub_heading_wrapper mb-0">
                                                            <h2>Sub Admin Listing</h2>
                                                        </div>
                                                    </div>

                                                    <div className="common-right-blk">
                                                        <div className="common-sort-blk">

                                                            <div className="common-search-blk">
                                                                <input
                                                                    ref={searchRef}
                                                                    type="search"
                                                                    className="form-control"
                                                                    id="search"
                                                                    value={query}
                                                                    placeholder="Search"
                                                                    onChange={(e) =>
                                                                        setQuery(e.target.value)
                                                                    }
                                                                    name="user_search"
                                                                />
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>

                                                <div className="table-blk table-responsive">
                                                    <table className="table">

                                                        <thead>
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>Full Name</th>
                                                            <th>Email</th>
                                                            <th>Created At</th>
                                                            <th>User Role</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                        </thead>

                                                        <tbody>
                                                        {subAdmin.results.map((admin, index) => (
                                                            <tr key={admin.id}>

                                                                <td>
                                                                    {index + 1 + (currentPage - 1) * 20}
                                                                </td>

                                                                <td className="text-capitalize">
                                                                    {admin.first_name} {admin.last_name}
                                                                </td>

                                                                <td >{admin.email}</td>

                                                                <td>{admin.created_at}</td>

                                                                <td className="text-capitalize">
                                                                    {admin.sub_admin_role
                                                                        ? admin.sub_admin_role.replaceAll(
                                                                            "_",
                                                                            " "
                                                                        )
                                                                        : "N/A"}
                                                                </td>

                                                                <td>
                                                                    {admin.is_active ? (
                                                                        <span className="badge bg-light text-success">
                                        Active
                                      </span>
                                                                    ) : (
                                                                        <span className="badge bg-light text-danger">
                                        Deactivated
                                      </span>
                                                                    )}
                                                                </td>

                                                                <td>

                                                                    {/* View */}
                                                                    <Link
                                                                        to={`/admin/${admin.id}`}
                                                                        className="border-0 bg-white"
                                                                    >
                                                                        <img
                                                                            src={
                                                                                IMAGE_URL +
                                                                                "eye-tbl-icon.svg"
                                                                            }
                                                                            alt="View"
                                                                        />
                                                                    </Link>

                                                                    {/* Activate / Deactivate */}
                                                                    {admin.is_active ? (
                                                                        <button
                                                                            type="button"
                                                                            className="border-0 bg-white"
                                                                            onClick={() =>
                                                                                handleDeactivateClick({
                                                                                    user_id: admin.id,
                                                                                    name:
                                                                                        admin.first_name +
                                                                                        " " +
                                                                                        admin.last_name,
                                                                                })
                                                                            }
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="26"
                                                                                height="26"
                                                                                fill="currentColor"
                                                                                className="bi bi-toggle-off ms-1"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    d="M11 4a4 4 0 0 1 0 8H8a5 5 0 0 0 2-4 5 5 0 0 0-2-4zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8M0 8a5 5 0 0 0 5 5h6a5 5 0 0 0 0-10H5a5 5 0 0 0-5 5"/>
                                                                            </svg>
                                                                        </button>
                                                                    ) : (
                                                                        <button
                                                                            type="button"
                                                                            className="border-0 bg-white ms-1"
                                                                            onClick={() =>
                                                                                handleActivateClick({
                                                                                    user_id: admin.id,
                                                                                    name:
                                                                                        admin.first_name +
                                                                                        " " +
                                                                                        admin.last_name,
                                                                                })
                                                                            }
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width="26"
                                                                                height="26"
                                                                                fill="currentColor"
                                                                                className="bi bi-toggle-on"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8"/>
                                                                            </svg>
                                                                        </button>
                                                                    )}

                                                                    {/* Reset Password */}
                                                                    <button
                                                                        type="button"
                                                                        className="border-0 bg-white ms-1"
                                                                        onClick={() =>
                                                                            handleResetPasswordClick({
                                                                                user_id: admin.id,
                                                                                name:
                                                                                    admin.first_name +
                                                                                    " " +
                                                                                    admin.last_name,
                                                                            })
                                                                        }
                                                                        title="Reset Password"
                                                                    >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="26"
                                                                            height="24"
                                                                            fill="currentColor"
                                                                            className="bi bi-person-lock"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path
                                                                                d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 5.996V14H3s-1 0-1-1 1-4 6-4q.845.002 1.544.107a4.5 4.5 0 0 0-.803.918A11 11 0 0 0 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664zM9 13a1 1 0 0 1 1-1v-1a2 2 0 1 1 4 0v1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zm3-3a1 1 0 0 0-1 1v1h2v-1a1 1 0 0 0-1-1"/>
                                                                        </svg>
                                                                    </button>

                                                                    {/* Delete */}
                                                                    <button
                                                                        type="button"
                                                                        className="border-0 bg-white ms-1"
                                                                        onClick={() =>
                                                                            handleDeleteClick({
                                                                                user_id: admin.id,
                                                                                name:
                                                                                    admin.first_name +
                                                                                    " " +
                                                                                    admin.last_name,
                                                                            })
                                                                        }
                                                                    >
                                                                        <img
                                                                            src={
                                                                                IMAGE_URL +
                                                                                "trash-icon.svg"
                                                                            }
                                                                            alt="Trash"
                                                                        />
                                                                    </button>

                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>

                                                    </table>
                                                </div>

                                                {/*note message */}

                                                <div
                                                  style={{
                                                    marginTop: "16px",
                                                    padding: "10px 14px",
                                                    backgroundColor: "#f8f9fa",
                                                    border: "1px solid #e5e7eb",
                                                    borderRadius: "6px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      fontWeight: "600",
                                                      color: "red",
                                                    }}
                                                  >
                                                    Note:
                                                  </span>

                                                  <span
                                                    style={{
                                                      fontSize: "13px",
                                                      color: "#6c757d",
                                                    }}
                                                  >
                                                    The currently logged-in user (you) is not included in this listing.
                                                  </span>
                                                </div>

                                                {/* Footer */}
                                                <TableFooter
                                                    pagination={pagination}
                                                    currentPage={currentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />

                                            </div>
                                        )}

                                        {/* Delete Modal */}
                                        <DeleteModal
                                            show={showModal}
                                            onClose={() => setShowModal(false)}
                                            onConfirm={handleConfirmDelete}
                                            itemName={
                                                selectedItem ? selectedItem.name : ""
                                            }
                                        />

                                        {/* Activate Modal */}
                                        <UserActivateModal
                                            show={showActiveModal}
                                            onClose={() => setActiveShowModal(false)}
                                            onConfirm={handleConfirmActivation}
                                            itemName={
                                                selectedItem ? selectedItem.name : ""
                                            }
                                        />

                                        {/* Deactivate Modal */}
                                        <UserDeactivateModal
                                            show={showDeactiveModal}
                                            onClose={() =>
                                                setDeactiveShowModal(false)
                                            }
                                            onConfirm={handleConfirmDeactivateClick}
                                            itemName={
                                                selectedItem ? selectedItem.name : ""
                                            }
                                        />

                                        {/* Password Reset Confirmation Modal */}
                                        {showPasswordResetConfirm && (
                                            <div
                                                className="modal show d-block"
                                                tabIndex="-1"
                                                style={{
                                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                                }}
                                            >
                                                <div className="modal-dialog">
                                                    <div className="modal-content">

                                                        <div className="modal-header">
                                                            <h5 className="modal-title">
                                                                Reset Password
                                                            </h5>

                                                            <button
                                                                type="button"
                                                                className="btn-close"
                                                                onClick={() =>
                                                                    setShowPasswordResetConfirm(false)
                                                                }
                                                            ></button>
                                                        </div>

                                                        <div className="modal-body">
                                                            <p>
                                                                Are you sure you want to reset the
                                                                password for{" "}
                                                                <strong>
                                                                    {selectedItem?.name}
                                                                </strong>
                                                                ?
                                                            </p>

                                                            <p>
                                                                A password reset email will be sent
                                                                to this user.
                                                            </p>
                                                        </div>

                                                        <div className="modal-footer">

                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                                onClick={() =>
                                                                    setShowPasswordResetConfirm(false)
                                                                }
                                                            >
                                                                Cancel
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="btn btn-warning"
                                                                onClick={
                                                                    handleConfirmPasswordReset
                                                                }
                                                                disabled={isResettingPassword}
                                                            >
                                                                {isResettingPassword
                                                                    ? "Sending..."
                                                                    : "Reset Password"}
                                                            </button>

                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </>
    );
}